import type { TranslateService } from '@ngx-translate/core';
import type { WebWidgetModel, WidgetMetaData } from '@web/types';
import type { SocialEntity } from '@sites/entity-core';

import { Widgets } from '@common/enums';
import { defaultWidgetParams, defaultWidgetPermission } from '@common/constants';
import { createSocial } from '@sites/entity-core';

import { SocialViewComponent } from '../components/social-view/social-view.component';
import { SocialControlComponent } from '../components/social-control/social-control.component';

// DEFAULT COMPONENT SETTINGS — sourced from the canonical entity factory in @sites/entity-core.
// Unlike button, the seeded social item needs no host-only overrides (no i18n label, no
// generated element id), so the factory is called bare.
//
// `data` is a function (not a static object) so `WebWidgetsFactoryService.prepareWidgetData`
// invokes it with `meta` — a social widget dropped into a zero block starts from the zero
// variant's defaults (`type: 'zero'` envelope tag, extended-position grid).
const socialData = (translate: TranslateService, meta?: WidgetMetaData): SocialEntity['data'] => {
    const entity = meta?.type === 'zero' ? createSocial('zero') : createSocial('default');

    return entity.data as SocialEntity['data'];
};
// END DEFAULT SETTINGS

export const socialWidgetModel: WebWidgetModel = {
    componentView: SocialViewComponent,
    componentControl: SocialControlComponent,
    name: Widgets.SOCIAL_NETWORKS,
    label: 'widget_social_label',
    data: socialData,
    permission: defaultWidgetPermission,
    params: { ...defaultWidgetParams, type: ['default', 'specific', 'zero'] },
    signalForm: true,
};
